import React from "react";
import {
  Box,
  Button,
  CircularProgress,
  List,
  ListItem,
  Typography,
} from "@mui/material";
// import DragHandleIcon from "@mui/icons-material/DragHandle";

const SearchResultsList = ({ results, isLoading, addProduct }) => {
  if (isLoading) {
    return <CircularProgress />;
  }

  return (
    <Box sx={{ width: "100%", marginTop: 4, maxHeight: "400px" }}>
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          flexDirection: "column",
          maxHeight: "400px",
          overflow: "scroll",
        }}
      >
        <Box>
          <List>
            {results.map((r) => (
              <ListItem
                key={r.productFormatId}
                sx={{
                  backgroundColor: (theme) => theme.palette.terrain[50],
                  minHeight: "48px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  padding: 2,
                  borderBottom: "1px solid",
                  borderColor: (theme) => theme.palette.terrain[300],
                }}
                // onClick={() => toggleSelected(!selected)}
              >
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    flex: 1,
                    paddingRight: 2,
                    minWidth: 0,
                  }}
                >
                  <Typography
                    variant="body1"
                    sx={{
                      wordBreak: "break-word",
                      whiteSpace: "normal",
                    }}
                  >
                    {r.displayName}
                  </Typography>
                </Box>
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    flexShrink: 0,
                  }}
                >
                  <Button onClick={() => addProduct(r.productFormatId, r.displayName)}>
                    +Add
                  </Button>
                </Box>
              </ListItem>
            ))}
          </List>
        </Box>
      </Box>
    </Box>
  );
};

export default SearchResultsList;
